import React, { useState } from "react";
import Slider from "react-slick";
// Rest of your code...
const ThumbnailSlider = ({ thumbnailImages, onThumbnailClick }) => {
  const [activeThumbnailIndex, setActiveThumbnailIndex] = useState(0);
  
  const settings = {
    dots: false,
    infinite: false,
    vertical: false,
    slidesToShow: Math.min(5, thumbnailImages?.length || 5),
    slidesToScroll: 1,
    arrows: thumbnailImages?.length > 5,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(4, thumbnailImages?.length || 4),
          slidesToScroll: 1,
          variableWidth: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(3, thumbnailImages?.length || 3),
          slidesToScroll: 1,
          variableWidth: true,
        }
      }
    ]
  };

  const handleClick = (index) => {
    onThumbnailClick(index);
    setActiveThumbnailIndex(index);
  };
  // onThumbnailClick = onThumbnailClick || (() => {});
  return (
    <div className="w-full thumbnail-slider-container">
      <Slider className="product-thumbnail-slick" {...settings}>
        {thumbnailImages.map((imageUrl, index) => (
          <div
            key={index}
            style={{ width: '80px' }}
          >
            <div
              className={`w-[72px] h-[72px] rounded-lg overflow-hidden cursor-pointer transition-all ${
                index === activeThumbnailIndex ? "border-2 border-black-900" : "border border-gray-300"
              }`}
              onClick={() => handleClick(index)}
            >
              <img src={imageUrl} alt={`Thumbnail ${index + 1}`} className="w-full h-full object-cover" />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export { ThumbnailSlider };